import React from "react";
import "./Footer.css"; // Import the custom CSS file
import { FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <>
      <div className="newsletter-box">
        <h2>Want to receive exclusive travel deals?</h2>
        <p>Subscribe to our Newsletter</p>
      </div>
      <div className="newsletter-form">
        <input type="email" placeholder="Email address" />
        <button className="subscribe-btn">Subscribe</button>
      </div>
      <footer className="footer-container">
      <div className="footer-content">
        {/* ✅ Left Section */}
        <div className="footer-left">
          <h3 className="footer-logo">RideHire, <span>Inc.</span></h3>
          <p>5100 Westheimer Road Houston Texas 77096</p>
          <div className="footer-icons">
            <FaFacebookF />
            <FaTwitter />
            <FaInstagram />
          </div>
        </div>

        {/* ✅ Right Section */}
        <div className="footer-right">
          <ul className="footer-links">
            <li>Our Story</li>
            <li>Help & Support</li>
            <li>Become an Affiliate</li>
            <li>Contact</li>
          </ul>
        </div>
      </div>

      {/* ✅ Bottom Footer Links */}
      <div className="footer-bottom">
        <p>© RideHire Technologies, Inc - 2021</p>
        <ul>
          <li>Terms of Transportation</li>
          <li>Terms & Condition</li>
          <li>Privacy Policy</li>
          <li>FAQs</li>
        </ul>
      </div>
    </footer>
    </>

  );
};

export default Footer;
